'use client';

import { useQuery } from '@tanstack/react-query';

import { useAuth } from '@/providers/auth-provider';

type ReferralCodeResponse = {
  referralCode: string;
  inviteUrl: string;
};

/**
 * Hook to fetch the authenticated user's referral code and invite URL
 * The backend generates the correct invite URL with the proper query parameter
 */
export function useReferralCode() {
  const { isAuthenticated, isLoading: isAuthLoading } = useAuth();

  return useQuery<ReferralCodeResponse>({
    queryKey: ['referral', 'code'],
    queryFn: async ({ signal }) => {
      const response = await fetch('/api/referral/code', { signal });

      if (!response.ok) {
        throw new Error('Failed to fetch referral code');
      }

      return response.json() as Promise<ReferralCodeResponse>;
    },
    enabled: isAuthenticated && !isAuthLoading,
  });
}
